import React, { useEffect } from "react";
import ContractGenerator from "./QuotationSearch/ContractGenerator/ContractGenerator";

const GenerateContractModal = ({
  quotation,
  vehicleQuantity,
  setQuotationStatus,
  index,
  onClosed,
}) => {
  // LS-747 : ContractGenerator initialise son formulaire une seule fois au montage.
  // Vider quotationOpened à la fermeture démonte la modale : chaque ouverture
  // repart de l'état courant de la ligne (l'ancien montage permanent envoyait
  // à Hitech les prix d'une version antérieure du devis).
  useEffect(() => {
    if (!window.$ || !onClosed) return;
    const $modal = window.$("#genContractModal");
    $modal.on("hidden.bs.modal", onClosed);
    return () => $modal.off("hidden.bs.modal", onClosed);
  }, [onClosed]);

  return (
    <>
      <div
        className="modal fade"
        id="genContractModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="contractModalLabel"
        aria-hidden="true"
      >
        <div
          className="modal-dialog"
          role="document"
          style={{ maxWidth: "90%" }}
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="contractModalLabel">
                Générer des contrats
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <ContractGenerator
                quotation={quotation}
                onGEnerateContract={(data) =>
                  setQuotationStatus(index, 3, data)
                }
              />
              {/* <Control
                label={"Nombre de contrats à générer (max " + nbLeft + ")"}
                name="quantity"
                type="number"
                value={quantity}
                change={(e) => setQuantity(e.target.value)}
              />
              <ul className="list-group">
                {caracs.map((c, k) => {
                  return (
                    <li className="list-group-item">
                      <span className="badge badge-primary">{k + 1}</span>
                      <div className="input-group">
                        <Control
                          label={"Immatriculation véhicule"}
                          name="immat"
                          value={c.immat}
                          k={k}
                          change={changeCarac}
                        />
                        <span className="mr-2" />
                        <Control
                          label={"Numéro de série"}
                          name="serialNumber"
                          value={c.serialNumber}
                          k={k}
                          change={changeCarac}
                        />
                        <span className="mr-2" />
                        <Control
                          label={"Date de mise en circulation"}
                          name="inroadDate"
                          type="date"
                          value={c.inroadDate}
                          k={k}
                          change={changeCarac}
                        />
                        <span className="mr-2" />
                        <Control
                          label={"Date de début contrat"}
                          name="dBegin"
                          type="date"
                          value={c.dBegin}
                          k={k}
                          change={changeCarac}
                        />
                      </div>
                    </li>
                  );
                })}
              </ul> */}
            </div>
            <div className="modal-footer">
              <button
                id="close-client-modal"
                type="button"
                className="btn btn-default"
                data-dismiss="modal"
              >
                Fermer
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default GenerateContractModal;
